import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI.js'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI.js'
import CustomerInvoicesCreateModalSF from './CustomerInvoicesCreateModalSF.js'
import CustomerInvoicesUpdateModalSF from './CustomerInvoicesUpdateModalSF.js'
import BadgeUI from '../../../widgets/output/BadgeUI.js'
import { Link } from 'react-router-dom'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'
import InvoiceItemCreateModalSF from './InvoiceItemCreateModalSF.js'
import InvoiceItemUpdateModalSF from './InvoiceItemUpdateModalSF.js'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'


const CustomerInvoices2PageUI = ({ context, account, invoiceList, customerList, onRefreshClick,
  createMode, onCreateClick, onCancelCreateInvoice, updateMode, onCancelClick, onUpdateClick, selectedInvoice, onUploadInvoiceClick,
  onUploadInvoice, onUploadMode, onUploadInvoiceCancelClick, onDownloadClick, onDeleteClick, invoiceItemList, onCancelCreateInvoiceItem,
  onCreateInvoiceItemClick, createInvoiceItemMode, invoice, onUpdateInvoiceItemClick, invoiceItemUpdateMode, onUpdateInvoiceItemCancelClick,
  onDeleteInvoiceClick, onDeleteItemClick

}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_cal' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!account && !invoiceList}
    account={account} page='invoices'
  >
    {
      (!account && !invoiceList) &&
      <SpinnerComponentUI />
    }
    {
      account && invoiceList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <IconButtonUI icon='icon-plus' onClick={onCreateClick} />
              <span className='g_m_left_100 g_large'><b>Customer Invoices</b></span>
            </div>
          }
          right={
            <div className='g_flex_h'>

            </div>
          }
        />
        {
          invoiceList.length !== 0 && <LRTableBodyUI>
            {
              invoiceList.map((invoice, i) =>
                <InvoiceRowUI key={i} context={context} invoice={invoice} onUpdateClick={onUpdateClick} onUploadInvoiceClick={onUploadInvoiceClick} onDownloadClick={onDownloadClick} onDeleteClick={onDeleteClick}
                  invoiceItemList={invoiceItemList} onCreateInvoiceItemClick={onCreateInvoiceItemClick} onUpdateInvoiceItemClick={onUpdateInvoiceItemClick} onDeleteInvoiceClick={onDeleteInvoiceClick}
                  onDeleteItemClick={onDeleteItemClick} />
              )
            }
          </LRTableBodyUI>
        }
        {
          invoiceList.length === 0 &&
          <div className='g_m_top_50'>
            <EmptyListUI
              context={context}
              createEnabled={false}
              createDisabledMessageLabel='No customer invoices'
            />
          </div>
        }
      </div>
    }
    <CustomerInvoicesCreateModalSF context={context} account={account} createMode={createMode}
      onCancelCreate={onCancelCreateInvoice} onRefreshClick={onRefreshClick} customerList={customerList} />
    {
      // invoice && (
      <InvoiceItemCreateModalSF context={context} account={account} invoice={invoice} createMode={createInvoiceItemMode}
        onCancelCreate={onCancelCreateInvoiceItem} onRefreshClick={onRefreshClick} selectedInvoice={selectedInvoice} invoiceItemList={invoiceItemList} />
      // )
    }
    <CustomerInvoicesUpdateModalSF context={context} account={account} updateMode={updateMode}
      onCancelClick={onCancelClick} onRefreshClick={onRefreshClick} customerList={customerList} selectedInvoice={selectedInvoice} />
    <InvoiceItemUpdateModalSF context={context} account={account} invoiceItemUpdateMode={invoiceItemUpdateMode}
      onCancelClick={onUpdateInvoiceItemCancelClick} onRefreshClick={onRefreshClick} selectedInvoice={selectedInvoice} />
    {account && invoiceList && selectedInvoice && (
      <FileUploadModalSF
        context={context}
        titleLabel='Upload Invoice'
        uploadMode={onUploadMode}
        onCancelClick={onUploadInvoiceCancelClick}
        signedUrlApi={`/api/accounts/${account.accountId}/fileUploadSignedUrl`}
        onUpload={onUploadInvoice}
      />
    )}
  </SuperUserAccountPageUI>

const InvoiceRowUI = ({ context, invoice, onDisburseClick, onInterestPaymentClick, onUpdateClick, onUploadInvoiceClick, onDownloadClick, onDeleteClick, onCreateInvoiceItemClick, onUpdateInvoiceItemClick, onDeleteInvoiceClick, onDeleteItemClick }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={
      <RowLeftUI invoice={invoice} onUpdateClick={onUpdateClick} onUploadInvoiceClick={onUploadInvoiceClick} onDownloadClick={onDownloadClick} onDeleteClick={onDeleteClick} onCreateInvoiceItemClick={onCreateInvoiceItemClick}
        onUpdateInvoiceItemClick={onUpdateInvoiceItemClick} onDeleteItemClick={onDeleteItemClick} />
    }
    right={
      <RowRightUI invoice={invoice} onDisburseClick={onDisburseClick} onInterestPaymentClick={onInterestPaymentClick} onUpdateClick={onUpdateClick} onDeleteInvoiceClick={onDeleteInvoiceClick} />
    }
    rowId={invoice.invoiceId}
  />

const RowLeftUI = ({ invoice, onUploadInvoiceClick, onDownloadClick, onDeleteClick, invoiceItemList, onCreateInvoiceItemClick, onUpdateInvoiceItemClick, onDeleteItemClick }) =>
  <div>
    <div>
      <table className='g_full_width '>
        <thead>
          <tr>
            <th className='g_p_right_100'>Invoice</th>
            <th className='g_p_left_100'>Customer</th>
            <th className='g_p_left_100'>Order</th>
            <th className='g_p_left_100'>Others</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className='g_text_top'>
              <LabelAndValueUI className='g_p_left_100' label='Invoice name'>{invoice.invoiceName}</LabelAndValueUI>
              <LabelAndValueUI label='Invoice number' className='g_p_left_100'>{invoice.invoiceNumber}</LabelAndValueUI>
              <LabelAndValueUI label='Invoice date' className='g_p_left_100'>{invoice.invoiceDateF1}</LabelAndValueUI>
            </td>
            <td className='g_text_top'>
              <LabelAndValueUI label='Customer name' className='g_p_left_100'>{invoice.customerName}</LabelAndValueUI>
              <LabelAndValueUI label='Customer notes' className='g_p_left_100'>{invoice.customerNotes}</LabelAndValueUI>
              <LabelAndValueUI label='Product description' className='g_p_left_100'>{invoice.productDescription}</LabelAndValueUI>
            </td>
            <td className='g_text_top'>
              <LabelAndValueUI label='Order number' className='g_p_left_100'>{invoice.orderNumber}</LabelAndValueUI>
              <LabelAndValueUI label='Order date' className='g_p_left_100'>{invoice.orderDateF1}</LabelAndValueUI>
              <LabelAndValueUI label='Date of supply' className='g_p_left_100'>{invoice.dateOfSupplyF1}</LabelAndValueUI>
            </td>
            <td className='g_text_top'>
              <LabelAndValueUI label='E-way bill' className='g_p_left_100'> {invoice.eWayBill}</LabelAndValueUI>
              <LabelAndValueUI label='Vehicle number' className='g_p_left_100'>{invoice.vehicleNumber}</LabelAndValueUI>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <Link onClick={onUploadInvoiceClick} data-invoice-id={invoice.customerInvoiceId} to='#'>Upload Invoice</Link>

    {invoice.fileList && invoice.fileList.length > 0 && (
      <div>
        <h5>Uploaded Files:</h5>
        <ul>
          {invoice.fileList.map((file, i) => (
            <li key={i}>
              {file.fileName}
              <span className="icon icon-download g_muted g_m_right_50 g_cursor_pointer" onClick={onDownloadClick} data-file-name={file.fileName} data-invoice-id={invoice.customerInvoiceId} />
              <span className='icon icon-trash-o g_m_left_25 g_cursor_pointer g_muted' onClick={onDeleteClick}
                data-file-name={file.fileName} data-invoice-id={invoice.customerInvoiceId}></span>
            </li>
          ))}
        </ul>
      </div>
    )}

    <div className='g_flex_h'>
      <span><b>Invoice Items</b></span>
      <span className='icon icon-plus' data-invoice-id={invoice.customerInvoiceId}
        onClick={onCreateInvoiceItemClick}

      />
    </div>
    <InvoiceItemsTable invoiceItemList={invoiceItemList} onCreateInvoiceItemClick={onCreateInvoiceItemClick} invoice={invoice} onUpdateInvoiceItemClick={onUpdateInvoiceItemClick}
      onDeleteItemClick={onDeleteItemClick} />
  </div>

const InvoiceItemsTable = ({ onUpdateInvoiceItemClick, invoice, onDeleteItemClick }) => {
  if (!invoice) {
    return null;
  }

  if (invoice.invoiceItemList && invoice.invoiceItemList.length > 0) {
    return (
      <table className='g_m_top_25'>
        <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          {invoice.invoiceItemList.map((item, index) => (
            <tr key={index}>
              <td className='g_text_right'>{item.itemName || 'N/A'}</td>
              <td className='g_text_right'>{item.quantity || 'N/A'}</td>
              {invoice.status === 'Open' && (
                <><span className='icon icon-pencil g_link_2' onClick={onUpdateInvoiceItemClick} data-invoice-id={invoice.customerInvoiceId} />
                  <span className='icon icon-trash-o g_m_left_25 g_cursor_pointer g_muted' onClick={onDeleteItemClick}
                    data-invoice-id={invoice.customerInvoiceId} data-product-item={item.productItemId}></span></>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  return (
    <div className='g_flex_h g_m_top_25'>
      <div>No items</div>
    </div>
  );
};

const RowRightUI = ({ invoice, onUpdateClick, onDeleteInvoiceClick }) =>
  <div className='g_flex_v g_text_right'>
    <span className='g_m_left_50'><BadgeUI label={invoice.status} /></span>
    <LabelAndValueUI label='Invoice Amount' className='g_p_left_100'>{invoice.invoiceAmountF5}</LabelAndValueUI>
    <span className='g_m_left_50'>
      <span className='icon icon-pencil g_link_2' onClick={onUpdateClick} data-invoice-id={invoice.customerInvoiceId} />
    </span>
    {invoice.status === 'Open' && (
      <span
        className='icon icon-trash-o g_m_left_25 g_cursor_pointer g_muted'
        onClick={onDeleteInvoiceClick}
        data-invoice-id={invoice.customerInvoiceId}
      ></span>
    )}

    <span className='g_small'>{invoice.disbursedDateF1}</span>
  </div>

export default CustomerInvoices2PageUI












